import { type FC } from 'react'

import { useTranslation } from 'react-i18next'

import './_groupCircles.scss'

type GroupAvatar =
  | string
  | {
      url: string | null
      displayName?: string
    }

const GroupCircles: FC<{
  group: { avatars: GroupAvatar[]; count: number }
  customClass?: string
  size: string
  onClick?: () => void
}> = ({ group, customClass, size, onClick }) => {
  const { t } = useTranslation()

  const fansNumber = () => {
    if (group.count > 4 && group.count < 1004) return `+${group.count - 4}`
    return `+${(group.count / 1000).toFixed(1)}k`
  }

  return (
    <div
      onClick={onClick}
      className={`groupCircles ${customClass ?? ''} groupCircles--${size}`}
    >
      {group.avatars.slice(0, 4).map((avatar, idx) => {
        const url = typeof avatar === 'string' ? avatar : avatar.url
        const displayName = typeof avatar === 'string' ? '' : avatar.displayName ?? ''

        return (
          <div
            className={`groupCircles__avatar ${!url ? 'is-placeholder' : ''}`}
            key={idx}
          >
            {url ? (
              <img
                className='avatar'
                src={url}
                alt={t('avatar')}
                loading='lazy'
                decoding='async'
                referrerPolicy='no-referrer'
              />
            ) : (
              <span className='groupCircles__initial'>
                {displayName.trim().charAt(0).toUpperCase()}
              </span>
            )}
          </div>
        )
      })}

      {group.count > 4 && (
        <div className='groupCircles__overlay'>{fansNumber()}</div>
      )}
    </div>
  )
}

export default GroupCircles